<template>
  <section class="sec sec-graph bg-light" v-if="result">
		<div class="bg-primary cta" style="padding: 30px;">
      <div class="row">
        <div class="colxs-12 col-sm-8 col-md-8">
          <h3 style="margin: 0px;"><strong>Results Breakdown</strong></h3>
        </div>
        <!-- <div class="colxs-12 col-sm-4 col-md-4" >
					<p class="text-center"><span class="price">{{format(result.totalCosts)}}</span></p>
				</div> -->
      </div>
		</div>
    <div>
      <article class="mb-30" style="font-size: 12px;">
        <p style="padding-left: 20px;">Under the assumptions above and values in the calculator, we get the following result breakdown:</p>
        <!-- <p style="padding-left: 20px; font-style: italic; margin-bottom: 0px;">Total amount: {{format(result.totalCosts)}}</p> -->
        <p style="padding-left: 30px; padding-right: 15px; margin-bottom: 10px;">
          <span style="margin-bottom: 0px;"><b>The total amount: {{format(result.totalCosts)}}</b></span>
          is the present value of future pension payments, admin expenses, upfront overhead, and potential reserve capital. Future payments are discounted at the real (after inflation) interest rate of
          {{$store.getters.interest*100}}% to reflect the cost today of providing the pension in the future. The non-discounted future payments will be {{format(result.salesCost+result.admin+result.payments)}} after inflation.
        </p>
        <p style="padding-left: 30px; padding-right: 15px; margin-bottom: 10px;">
          <span style="margin-bottom: 0px;"><b>The Reserve Capital: {{ format(result.reserveCapAmount) }} </b></span>
          will be required if the pension is provided by a private sector company in order to ensure the pensioners will receive their annual payments even if they live longer than expected. This can be estimated at around 15%. A government provider of pensions may not explicitly put aside reserve capital against the same risk.
        </p>
        <p style="padding-left: 30px; padding-right: 15px; margin-bottom: 10px;">
          <span style=" margin-bottom: 0px;"><b> The Upfront Admin Costs: {{format(result.salesCost)}}</b></span>
          are the assumed cost of setting up the pension and “selling” it to the pensioner. Depending on if the provider is state, or private sector company, this number may vary.
        </p>

        <p style="padding-left: 30px; padding-right: 15px; margin-bottom: 10px;"><span style="margin-bottom: 0px;"><b>The ongoing Admin Costs: {{format(result.admin)}}</b></span> are the costs of administrating and running the pension. Until the payments start (age {{$store.getters.selectedAgePaymentsStart}} in this case) admin costs are reduced by 75%.</p>

        <p style="padding-left: 30px; padding-right: 15px; margin-bottom: 10px;"><span style="margin-bottom: 0px;"><b>The Pension payouts: {{format(result.payments)}}</b></span> is the total amount in expected payments to the pensioner after inflation (actual amounts will be higher due to inflation).</p>

        <p style="padding-left: 30px; margin-bottom: 15px;"><span style="margin-bottom: 0px;"><b>Life Expectancy: {{result.lifeExpectancy}} Years</b></span>. This is the expected age of death. We default to using World Health Organisation estimates.</p>

        <p v-if="!onAssumptionsPage" style="padding: 20px;">
          <router-link :to="{ name: 'assumptions', params: {} }">See or amend assumptions</router-link>
        </p>

        <p v-else style="padding: 20px;">
          <router-link :to="{ name: 'home', params: {} }">Back To Calculator</router-link>
        </p>
      </article>
    </div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import accounting from 'accounting'
import annuities from '../js/annuityCalc.js'

export default {
  name: 'Results',
  computed: {
    ...mapGetters([
      'result',
      'annualPayments',
      'countries',
      'selectedCurrentAge',
      'selectedAgePaymentsStart',
      'selectedCountry',
      'selectedGender'
    ]),
    onAssumptionsPage: function(){
      return this.$route.name == 'assumptions'
    }
  },
  methods:{
    format(amount){
      return accounting.formatMoney(amount, "$", 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.calc-form {
  border: 1px black solid;
  border-radius: 10px;
  background-color: white;
  /* box-shadow: 3px 6px #888888; */
  padding: 50px;
  padding-bottom: 40px;
  height: 424.74px;
  opacity: 0.8;
}

.btn-submit {
  width: 50%;
}

.form-label-left {
  text-align: left;
}
</style>
